import { Link } from 'react-router-dom';
import { MobileFrame } from '@/components/shared/MobileFrame';
import { DevBar } from '@/components/shared/DevBar';
import { Waves, ArrowRight } from 'lucide-react';

export function Landing() {
    return (
        <MobileFrame>
            <DevBar />
            <div className="flex min-h-screen md:h-[852px] flex-col justify-between p-8 bg-gradient-to-b from-zinc-950 via-blue-950/20 to-zinc-950">
                <div className="pt-20 flex flex-col items-center">
                    <div className="rounded-2xl bg-blue-500/10 border border-blue-500/30 p-4 mb-6">
                        <Waves className="w-10 h-10 text-blue-400" />
                    </div>
                    <h1 className="text-4xl font-bold tracking-tight text-zinc-100">SwimSuite</h1>
                    <p className="mt-3 text-sm text-zinc-400 text-center max-w-xs">
                        La PWA del nuoto agonistico italiano. Allenamenti, tempi, gare e squadra in un unico posto.
                    </p>
                </div>

                <div className="flex flex-col gap-3">
                    <Link
                        to="/auth/login"
                        className="flex items-center justify-between rounded-xl bg-blue-500 hover:bg-blue-600 px-5 py-4 text-sm font-semibold text-white transition-colors"
                    >
                        Accedi
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                    <Link
                        to="/auth/register"
                        className="flex items-center justify-center rounded-xl border border-zinc-700 bg-zinc-900/50 px-5 py-4 text-sm font-semibold text-zinc-200 hover:bg-zinc-800"
                    >
                        Registrati
                    </Link>
                    <div className="flex items-center gap-2 mt-2 text-xs text-zinc-500 justify-center">
                        <Link to="/coach" className="underline decoration-dotted">
                            Entra come Coach (demo)
                        </Link>
                        <span>·</span>
                        <Link to="/atleta" className="underline decoration-dotted">
                            Entra come Atleta (demo)
                        </Link>
                    </div>
                </div>
            </div>
        </MobileFrame>
    );
}
